<template>
    <div class="w-full h-full mx-auto bg-body flex overflow-hidden fixed">
        <div class="w-3/5 ml-4 my-4 mr-2 bg-module rounded-md font-bold flex flex-col overflow-hidden">
            <div class="flex-none text-aux font-bold tracking-wide text-lg my-2 ml-6">Ventas</div>
            <All @updated="getNewData" ref="sales" model="stock/Sales" :data.sync="totals" :immediate="true" v-slot="{ data }">
                <div class="flex flex-col flex-1">
                    <div class="flex flex-col h-full pb-4" v-if="Object.keys(totals).length !== 0">
                        <salesDonnutsCharts class="h-1/3 overflow-hidden" :summary="totals.data.summary"/>
                        <salesStore class="h-1/3 overflow-hidden" :stores="totals.data.stores"/>

                        <div class="flex-1 flex text-white overflow-hidden mx-4">
                            <salesRecords :records="totals.data.totals"/>

                            <div class="bg-box ml-2 w-full h-full rounded-md overflow-hidden">
                                <All @updated="getChartNewData" ref="chart" model="stock/SalesChart" :data.sync="chart" :immediate="true" v-slot="{ data }">
                                    <div class="h-full overflow-hidden flex flex-col">
                                        <div class="h-8">
                                            <span class="text-aux text-lg ml-2">Evolución ventas hoy vs hace un año</span>
                                        </div>
                                        <div v-if="Object.keys(chart).length !== 0" class="h-full overflow-hidden">
                                            <chartSalesArea :data="chart.data.evolution" chartId='graph'/>
                                        </div>
                                    </div>
                                </All>
                            </div>

                        </div>
                    </div>

                </div>
            </All>
        </div>
        <div class="w-2/5 my-4 mr-4 bg-module rounded flex flex-col overflow-hidden">
            <div class="ml-6 my-2 text-aux font-bold tracking-wide text-lg">Últimos pedidos</div>
            <div class="flex-1 overflow-hidden">
                <vue-scroll>
                    <ordersCard/>
                </vue-scroll>
            </div>
        </div>
    </div>

</template>

<script>

    import All from '@/api/components/All.vue';
    import ordersCard from '@/components/ordersCard.vue'
    import salesStore from '@/components/salesStore.vue'
    import salesRecords from '@/components/salesRecords.vue'
    import salesDonnutsCharts from '@/components/salesDonnutsCharts.vue'
    import chartSalesArea from '@/components/chartSalesArea.vue'

    export default {
        name: 'Sales',
        components:{
            All,
            ordersCard,
            salesStore,
            salesRecords,
            salesDonnutsCharts,
            chartSalesArea
        },
        data(){
            return {
                getNewDataTimeOut:false,
                getChartNewDataTimeOut:false,
                totals: {},
                chart: {}
            }  
        },

        methods: {
            getNewData(){
                clearTimeout(this.getNewDataTimeOut)
                this.getNewDataTimeOut =  setTimeout( () => {
                    this.$refs.sales.request()
                },  60 * 1000)
            },

           getChartNewData(){
               clearTimeout(this.getChartNewDataTimeOut)
               this.getChartNewDataTimeOut = setTimeout( () => {
                   this.$refs.chart.request()
               }, 60 *1000)
           } 
        }
    }
</script>

<style lang="scss">
    html{
        font-size: 0.833333333333vw;
        body {
            overflow: hidden;
        }
    }
    
    *::-webkit-scrollbar  {
        width: .5rem;
        height: .5rem;
    }
    *::-webkit-scrollbar-track  {

        background: transparent; 
    }

    *::-webkit-scrollbar-thumb  {
        background: #4AF1B1;
        border-radius: 20px;
    }
    * {
        // -webkit-overflow-scrolling: touch;
    }

</style>

